import React from 'react';
import 'normalize.css';
import LegalPopup from '../LegalPopup';
import s from './Layout.module.scss';
import classNames from 'classnames';

interface LayoutProps {
  children: React.ReactNode;
  pageClass?: string;
}

export default function BlankLayout ({
  children,
  pageClass
}: LayoutProps) {
  return (
    <div className={classNames(s.root, pageClass)}>
      {children}
      <LegalPopup />
    </div>
  );
};
